var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", [_c("el-form", {
    attrs: {
      "label-width": "100px"
    }
  }, [_c("el-form-item", {
    attrs: {
      label: "礼包ID"
    }
  }, [_c("el-input", {
    attrs: {
      disabled: true
    },
    model: {
      value: _vm.data.coupon_id,
      callback: function callback($$v) {
        _vm.$set(_vm.data, "coupon_id", $$v);
      },
      expression: "data.coupon_id"
    }
  })], 1), _c("el-form-item", {
    attrs: {
      label: "礼包名称"
    }
  }, [_c("el-input", {
    attrs: {
      disabled: true
    },
    model: {
      value: _vm.data.coupon_name,
      callback: function callback($$v) {
        _vm.$set(_vm.data, "coupon_name", $$v);
      },
      expression: "data.coupon_name"
    }
  })], 1), _c("el-form-item", {
    attrs: {
      label: "礼包码数量"
    }
  }, [_c("el-input-number", {
    attrs: {
      min: 1,
      max: _vm.maxNum
    },
    model: {
      value: _vm.num,
      callback: function callback($$v) {
        _vm.num = $$v;
      },
      expression: "num"
    }
  })], 1), _c("el-form-item", {
    attrs: {
      label: ""
    }
  }, [_c("div", [_c("el-switch", {
    attrs: {
      "active-text": "全渠道",
      "inactive-text": "多渠道"
    },
    model: {
      value: _vm.isAllChannel,
      callback: function callback($$v) {
        _vm.isAllChannel = $$v;
      },
      expression: "isAllChannel"
    }
  })], 1), _c("div", {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: !_vm.isAllChannel,
      expression: "!isAllChannel"
    }]
  }, [_c("el-checkbox-group", {
    model: {
      value: _vm.channelCheckedList,
      callback: function callback($$v) {
        _vm.channelCheckedList = $$v;
      },
      expression: "channelCheckedList"
    }
  }, _vm._l(_vm.channelList, function (channel) {
    return _c("el-checkbox", {
      key: channel.value,
      attrs: {
        label: channel.value
      }
    }, [_vm._v(" " + _vm._s(channel.label) + " ")]);
  }), 1)], 1)]), _c("el-form-item", {
    attrs: {
      label: "备注"
    }
  }, [_c("el-input", {
    model: {
      value: _vm.remark,
      callback: function callback($$v) {
        _vm.remark = $$v;
      },
      expression: "remark"
    }
  })], 1), _c("div", {
    staticStyle: {
      display: "flex",
      "justify-content": "center"
    }
  }, [_c("el-button", {
    attrs: {
      type: "primary"
    },
    on: {
      click: _vm.onConfirm
    }
  }, [_vm._v(" 确认生成 ")])], 1)], 1)], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };